import {fabric} from 'fabric';
import DefaultSquare from '../nuclide/levelhelpers/DefaultSquare';
import RowColSquare from '../nuclide/levelhelpers/RowColSquare'


export default function createOne(nuclide) {
    let items = [];

    if(nuclide.isRow || nuclide.isColumn) {
        new RowColSquare(nuclide, items, 2, false);
    } else {
        new DefaultSquare(nuclide, items, 2);
    }

    let group = new fabric.Group(items, {
        objectCaching: false,
        opacity: nuclide.opacity
    });

    return group;
};